import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function HistoryIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 9V4H9V7H12V9H7Z" fill="#29333D" />
        <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8H0C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C5.61062 16 3.46589 14.9525 2 13.2916L2 16L0 16V10H6V12H3.52779C4.62643 13.2275 6.223 14 8 14Z" />
      </svg>
    </Icon>
  );
}
